import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { formatViews, getCategorySlug, getHotMovies, getLatestMovies } from "@/lib/movieData";

const tags = ["动作", "悬疑", "科幻", "动画", "爱情", "冒险"];

export default function LatestSection() {
  const latest = getLatestMovies(6);
  const hot = getHotMovies(6);

  return (
    <section className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1180px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-7">
            <div>
              <p className="text-[11px] tracking-[0.3em] text-foreground-400 uppercase">Latest</p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">最新电影</h2>
              <p className="mt-2 text-sm text-foreground-600">按上映时间排序，收录近期定档与上线影片资料</p>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {tags.map((tag) => (
                <Link
                  key={tag}
                  to={`/category/${getCategorySlug(tag)}`}
                  className="h-8 px-3 inline-flex items-center rounded-full border border-background-300 text-xs text-foreground-600 hover:border-accent-300 hover:text-accent-700 hover:bg-accent-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_310px] gap-8 lg:gap-10">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 md:gap-x-5 gap-y-8">
              {latest.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>

            <aside className="flex flex-col gap-5">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950">本周热度榜</h3>
                  <span className="text-[11px] text-foreground-400">按浏览量</span>
                </div>
                <ul className="mt-4 divide-y divide-background-200">
                  {hot.map((movie, index) => (
                    <li key={movie.id}>
                      <Link
                        to={`/detail/${movie.id}`}
                        className="group flex items-center gap-3 py-3 cursor-pointer"
                      >
                        <span
                          className={`w-5 text-center font-heading text-base ${
                            index < 3 ? "text-accent-600" : "text-foreground-400"
                          }`}
                        >
                          {index + 1}
                        </span>
                        <div className="w-10 h-14 rounded overflow-hidden bg-background-200 shrink-0">
                          <img
                            src={movie.poster}
                            alt={`《${movie.title}》海报`}
                            title={`${movie.title} - 秋霞电影`}
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                        <div className="min-w-0 flex-1">
                          <p className="text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                            {movie.title}
                          </p>
                          <p className="mt-1 text-[11px] text-foreground-500">
                            {formatViews(movie.views)} 次浏览
                          </p>
                        </div>
                        <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-accent-500 transition-colors"></i>
                      </Link>
                    </li>
                  ))}
                </ul>
                <Link
                  to="/category/action"
                  className="mt-3 flex items-center justify-center h-10 rounded-md bg-background-100 text-xs text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  查看完整片库
                </Link>
              </div>

              <div className="rounded-lg bg-primary-500 p-5 text-background-50">
                <p className="text-[11px] tracking-[0.3em] text-primary-200 uppercase">Editor's Note</p>
                <p className="mt-3 font-heading text-lg leading-snug">本期编辑推荐 · 悬疑专题</p>
                <p className="mt-2 text-xs leading-relaxed text-primary-100/80">
                  从港口迷雾到午夜电台，我们整理了十部围绕「监听与窥视」展开的悬疑作品。
                </p>
                <Link
                  to="/category/mystery"
                  className="mt-4 inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-accent-500 text-xs font-medium text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap"
                >
                  进入专题
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}